import i18n from 'i18n';

export const convertVisaOptions = options =>
  options.map(item => ({
    label: item.translations[i18n.language],
    value: item.id,
    item: item,
    is_active: item.is_active,
  }));
